import { SvgIcon, type SvgIconProps } from './svgIcon'

export function SmsLoginLinkIcon({
  width = 318,
  height = 233,
  ...props
}: SvgIconProps) {
  return (
    <SvgIcon
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      {...props}>
      <path
        d="M282.919 163.315C282.919 170.412 277.086 176.256 270.003 176.256H251.531C250.142 176.256 248.892 176.812 247.92 177.787C246.948 178.761 246.392 180.013 246.392 181.404C246.392 184.187 248.614 186.553 251.531 186.553H258.892C260.419 186.553 261.808 187.249 262.919 188.223C263.892 189.197 264.586 190.727 264.586 192.258C264.586 195.319 262.086 197.963 258.892 197.963H149.867C146.812 197.963 144.173 195.459 144.173 192.258C144.173 189.197 146.673 186.553 149.867 186.553H170.7C172.089 186.553 173.339 185.996 174.311 185.022C175.283 184.048 175.839 182.796 175.839 181.404C175.839 178.621 173.616 176.256 170.7 176.256H165.561C161.95 176.256 158.756 174.864 156.395 172.499C154.034 170.133 152.645 166.933 152.645 163.315C152.645 156.218 158.478 150.374 165.561 150.374H270.003C273.614 150.374 276.808 151.766 279.169 154.131C281.391 156.497 282.919 159.836 282.919 163.315Z"
        fill="#D9E2FB"
      />
      <path
        d="M57.7621 97.9333H47.688"
        stroke="#DBDADA"
        strokeWidth="1.42"
        strokeMiterlimit="10"
      />
      <path
        d="M52.728 92.8984V102.972"
        stroke="#DBDADA"
        strokeWidth="1.42"
        strokeMiterlimit="10"
      />
      <path
        d="M51.5625 106.225H45.0542"
        stroke="#DBDADA"
        strokeWidth="1.42"
        strokeMiterlimit="10"
      />
      <path
        d="M48.3115 102.973V109.482"
        stroke="#DBDADA"
        strokeWidth="1.42"
        strokeMiterlimit="10"
      />
      <path
        d="M56.6349 112.444H75.5566V107.785H56.6349V112.444Z"
        fill="white"
      />
      <path d="M56.6349 121.05H75.5566V116.391H56.6349V121.05Z" fill="white" />
      <path
        d="M134.273 37.7832V105.414H34.1882C29.999 105.414 26.6074 102.022 26.6074 97.8328C26.6074 95.7415 27.4587 93.8514 28.826 92.4773C30.2001 91.11 32.1037 90.2587 34.1882 90.2587H40.6764C41.6684 90.2587 42.4794 89.4477 42.4794 88.4557C42.4794 87.457 41.6684 86.646 40.6764 86.646H19.4557C17.2572 86.646 15.481 84.8697 15.481 82.6779C15.481 80.4794 17.2572 78.7032 19.4557 78.7032H62.7618C65.6909 78.7032 68.0637 76.3305 68.0637 73.4015C68.0637 71.9336 67.4671 70.6131 66.5086 69.6546C65.5501 68.6961 64.2163 68.0995 62.7618 68.0995H44.4299C36.0583 68.0995 29.2684 61.3098 29.2684 52.9381C29.2684 48.7556 30.9709 44.9619 33.7123 42.2205C36.4537 39.4724 40.2407 37.7765 44.4299 37.7765H134.28L134.273 37.7832Z"
        fill="#D9E2FB"
      />
      <path
        d="M332.492 220.512H36.2593"
        stroke="black"
        strokeWidth="1.42"
        strokeMiterlimit="10"
      />
      <path
        d="M104.353 182.109C121.865 182.109 136.047 167.915 136.047 150.415C136.047 132.914 121.854 118.721 104.353 118.721H94.8389V182.119H104.353V182.109Z"
        fill="#DBDADA"
      />
      <mask
        id="mask0_11096_9094"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="94"
        y="118"
        width="43"
        height="65">
        <path
          d="M104.353 182.109C121.865 182.109 136.047 167.915 136.047 150.415C136.047 132.914 121.854 118.721 104.353 118.721H94.8389V182.119H104.353V182.109Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_11096_9094)">
        <path
          d="M58.9077 118.708H156.774"
          stroke="black"
          strokeWidth="1.42"
          strokeMiterlimit="10"
        />
        <path
          d="M58.9077 129.282H156.774"
          stroke="black"
          strokeWidth="1.42"
          strokeMiterlimit="10"
        />
        <path
          d="M58.9077 139.843H156.774"
          stroke="black"
          strokeWidth="1.42"
          strokeMiterlimit="10"
        />
        <path
          d="M58.9077 150.412H156.774"
          stroke="black"
          strokeWidth="1.42"
          strokeMiterlimit="10"
        />
        <path
          d="M58.9077 160.973H156.774"
          stroke="black"
          strokeWidth="1.42"
          strokeMiterlimit="10"
        />
        <path
          d="M58.9077 171.546H156.774"
          stroke="black"
          strokeWidth="1.42"
          strokeMiterlimit="10"
        />
        <path
          d="M58.9077 182.107H156.774"
          stroke="black"
          strokeWidth="1.42"
          strokeMiterlimit="10"
        />
      </g>
      <path
        d="M104.353 182.109C121.865 182.109 136.047 167.915 136.047 150.415C136.047 132.914 121.854 118.721 104.353 118.721H94.8389V182.119H104.353V182.109Z"
        stroke="black"
        strokeWidth="1.42"
        strokeMiterlimit="10"
      />
      <path
        d="M94.8292 182.109C112.333 182.109 126.523 167.919 126.523 150.415C126.523 132.91 112.333 118.721 94.8292 118.721C77.3251 118.721 63.1353 132.91 63.1353 150.415C63.1353 167.919 77.3251 182.109 94.8292 182.109Z"
        fill="white"
        stroke="black"
        strokeWidth="1.42"
        strokeMiterlimit="10"
      />
      <path
        d="M94.8281 177.879C109.997 177.879 122.293 165.582 122.293 150.414C122.293 135.245 109.997 122.948 94.8281 122.948C79.6594 122.948 67.3628 135.245 67.3628 150.414C67.3628 165.582 79.6594 177.879 94.8281 177.879Z"
        fill="#F0EEEE"
        stroke="black"
        strokeWidth="1.42"
        strokeMiterlimit="10"
      />
      <path d="M136.05 207.71H66.623V220.511H136.05V207.71Z" fill="white" />
      <mask
        id="mask1_11096_9094"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="66"
        y="207"
        width="71"
        height="14">
        <path d="M136.05 207.71H66.623V220.511H136.05V207.71Z" fill="white" />
      </mask>
      <g mask="url(#mask1_11096_9094)">
        <path
          d="M66.623 220.513V202.583"
          stroke="black"
          strokeWidth="1.42"
          strokeMiterlimit="10"
        />
        <path
          d="M78.1899 220.513V202.583"
          stroke="black"
          strokeWidth="1.42"
          strokeMiterlimit="10"
        />
        <path
          d="M89.7646 220.513V202.583"
          stroke="black"
          strokeWidth="1.42"
          strokeMiterlimit="10"
        />
        <path
          d="M101.344 220.513V202.583"
          stroke="black"
          strokeWidth="1.42"
          strokeMiterlimit="10"
        />
        <path
          d="M112.907 220.513V202.583"
          stroke="black"
          strokeWidth="1.42"
          strokeMiterlimit="10"
        />
        <path
          d="M124.486 220.513V202.583"
          stroke="black"
          strokeWidth="1.42"
          strokeMiterlimit="10"
        />
        <path
          d="M136.048 220.513V202.583"
          stroke="black"
          strokeWidth="1.42"
          strokeMiterlimit="10"
        />
      </g>
      <path
        d="M136.05 207.71H66.623V220.511H136.05V207.71Z"
        stroke="black"
        strokeWidth="1.42"
        strokeMiterlimit="10"
      />
      <path d="M128.691 194.909H59.2632V207.71H128.691V194.909Z" fill="white" />
      <mask
        id="mask2_11096_9094"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="59"
        y="194"
        width="70"
        height="14">
        <path
          d="M128.691 194.909H59.2632V207.71H128.691V194.909Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask2_11096_9094)">
        <path
          d="M59.2632 207.711V189.781"
          stroke="black"
          strokeWidth="1.42"
          strokeMiterlimit="10"
        />
        <path
          d="M70.8384 207.711V189.781"
          stroke="black"
          strokeWidth="1.42"
          strokeMiterlimit="10"
        />
        <path
          d="M82.4048 207.711V189.781"
          stroke="black"
          strokeWidth="1.42"
          strokeMiterlimit="10"
        />
        <path
          d="M93.9839 207.711V189.781"
          stroke="black"
          strokeWidth="1.42"
          strokeMiterlimit="10"
        />
        <path
          d="M105.547 207.711V189.781"
          stroke="black"
          strokeWidth="1.42"
          strokeMiterlimit="10"
        />
        <path
          d="M117.126 207.711V189.781"
          stroke="black"
          strokeWidth="1.42"
          strokeMiterlimit="10"
        />
        <path
          d="M128.701 207.711V189.781"
          stroke="black"
          strokeWidth="1.42"
          strokeMiterlimit="10"
        />
      </g>
      <path
        d="M128.691 194.909H59.2632V207.71H128.691V194.909Z"
        stroke="black"
        strokeWidth="1.42"
        strokeMiterlimit="10"
      />
      <path d="M136.05 182.107H66.623V194.908H136.05V182.107Z" fill="white" />
      <mask
        id="mask3_11096_9094"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="66"
        y="182"
        width="71"
        height="13">
        <path d="M136.05 182.107H66.623V194.908H136.05V182.107Z" fill="white" />
      </mask>
      <g mask="url(#mask3_11096_9094)">
        <path
          d="M66.623 194.91V176.98"
          stroke="black"
          strokeWidth="1.42"
          strokeMiterlimit="10"
        />
        <path
          d="M78.1899 194.91V176.98"
          stroke="black"
          strokeWidth="1.42"
          strokeMiterlimit="10"
        />
        <path
          d="M89.7646 194.91V176.98"
          stroke="black"
          strokeWidth="1.42"
          strokeMiterlimit="10"
        />
        <path
          d="M101.344 194.91V176.98"
          stroke="black"
          strokeWidth="1.42"
          strokeMiterlimit="10"
        />
        <path
          d="M112.907 194.91V176.98"
          stroke="black"
          strokeWidth="1.42"
          strokeMiterlimit="10"
        />
        <path
          d="M124.486 194.91V176.98"
          stroke="black"
          strokeWidth="1.42"
          strokeMiterlimit="10"
        />
        <path
          d="M136.048 194.91V176.98"
          stroke="black"
          strokeWidth="1.42"
          strokeMiterlimit="10"
        />
      </g>
      <path
        d="M136.05 182.107H66.623V194.908H136.05V182.107Z"
        stroke="black"
        strokeWidth="1.42"
        strokeMiterlimit="10"
      />
      <path
        d="M175.824 21.5408H211.301"
        stroke="#DBDADA"
        strokeWidth="1.42"
        strokeMiterlimit="10"
      />
      <path
        d="M223.09 26.7223H134.849C128.641 26.7223 123.608 31.7548 123.608 37.9627V209.27C123.608 215.478 128.641 220.511 134.849 220.511H223.09C229.298 220.511 234.33 215.478 234.33 209.27V37.9627C234.33 31.7548 229.298 26.7223 223.09 26.7223Z"
        fill="#DBDADA"
        stroke="black"
        strokeWidth="1.42"
        strokeMiterlimit="10"
      />
      <path
        d="M223.553 38.9748V45.1883H112.832V38.9748C112.832 32.2118 118.321 26.7223 125.084 26.7223H211.301C218.064 26.7223 223.553 32.2118 223.553 38.9748Z"
        fill="#F0EEEE"
        stroke="black"
        strokeWidth="1.42"
        strokeMiterlimit="10"
      />
      <path
        d="M223.553 202.053V208.266C223.553 215.029 218.064 220.519 211.301 220.519H125.084C118.321 220.519 112.832 215.029 112.832 208.266V202.053H223.553Z"
        fill="#F0EEEE"
        stroke="black"
        strokeWidth="1.42"
        strokeMiterlimit="10"
      />
      <path
        d="M223.553 45.1887H112.832V202.052H223.553V45.1887Z"
        fill="white"
        stroke="black"
        strokeWidth="1.42"
        strokeMiterlimit="10"
      />
      <path
        d="M92.0322 71.4826V64.2705H102.609"
        stroke="#DBDADA"
        strokeWidth="1.42"
        strokeMiterlimit="10"
      />
      <path
        d="M107.645 99.4727V84.1168"
        stroke="#DBDADA"
        strokeWidth="1.42"
        strokeMiterlimit="10"
      />
      <path
        d="M107.645 38.9745C107.645 29.3695 115.467 21.5408 125.085 21.5408H143.793"
        stroke="#DBDADA"
        strokeWidth="1.42"
        strokeMiterlimit="10"
      />
      <path
        d="M146.895 21.5408H154.596"
        stroke="#DBDADA"
        strokeWidth="1.42"
        strokeMiterlimit="10"
      />
      <path
        d="M201.773 175.999H190.358V187.414H201.773V175.999Z"
        fill="#DBDADA"
        stroke="black"
        strokeWidth="1.42"
        strokeMiterlimit="10"
      />
      <path
        d="M174.547 175.999H162.596C159.445 175.999 156.892 178.553 156.892 181.703V181.71C156.892 184.86 159.445 187.414 162.596 187.414H174.547C177.697 187.414 180.251 184.86 180.251 181.71V181.703C180.251 178.553 177.697 175.999 174.547 175.999Z"
        fill="#DBDADA"
        stroke="black"
        strokeWidth="1.42"
        strokeMiterlimit="10"
      />
      <path
        d="M146.777 181.704C146.777 185.062 144.056 187.783 140.698 187.783H138.077V187.187C136.032 186.208 134.618 184.123 134.618 181.704C134.618 179.284 136.032 177.199 138.077 176.221V175.624H140.698C144.056 175.624 146.777 178.346 146.777 181.704Z"
        fill="#DBDADA"
        stroke="black"
        strokeWidth="1.42"
        strokeMiterlimit="10"
      />
      <path
        d="M199.152 175.999H187.737V187.414H199.152V175.999Z"
        fill="white"
        stroke="black"
        strokeWidth="1.42"
        strokeMiterlimit="10"
      />
      <path
        d="M171.918 175.999H159.967C156.816 175.999 154.263 178.553 154.263 181.703V181.71C154.263 184.86 156.816 187.414 159.967 187.414H171.918C175.068 187.414 177.622 184.86 177.622 181.71V181.703C177.622 178.553 175.068 175.999 171.918 175.999Z"
        fill="white"
        stroke="black"
        strokeWidth="1.42"
        strokeMiterlimit="10"
      />
      <path
        d="M138.069 187.783C141.426 187.783 144.148 185.061 144.148 181.704C144.148 178.346 141.426 175.624 138.069 175.624C134.711 175.624 131.989 178.346 131.989 181.704C131.989 185.061 134.711 187.783 138.069 187.783Z"
        fill="white"
        stroke="black"
        strokeWidth="1.42"
        strokeMiterlimit="10"
      />
      <path
        d="M141.975 97.6275C143.729 97.6276 145.307 98.0776 146.684 98.9917C148.058 99.9038 149.105 101.182 149.83 102.799H149.829C150.578 104.385 150.943 106.211 150.943 108.257V108.967H144.417V108.257C144.417 107.067 144.152 106.201 143.696 105.591L143.688 105.581C143.24 104.959 142.688 104.676 141.975 104.676H141.813L141.668 104.607L137.551 102.635C137.217 102.605 136.908 102.499 136.652 102.387C136.354 102.258 136.049 102.085 135.827 101.968C135.573 101.835 135.413 101.766 135.303 101.742C135.299 101.741 135.296 101.739 135.292 101.739C135.169 101.839 134.999 101.956 134.826 102.068C134.609 102.208 134.338 102.376 134.039 102.56C133.434 102.931 132.702 103.375 131.988 103.831C131.271 104.288 130.595 104.744 130.104 105.134C130.007 105.212 129.921 105.285 129.845 105.351C129.797 105.735 129.773 106.134 129.773 106.55V108.887C130.007 109.059 130.286 109.234 130.603 109.399C131.598 109.918 132.806 110.308 133.618 110.485L143.798 111.891L143.825 111.895L143.851 111.901C146.218 112.412 148.1 113.339 149.427 114.729L149.671 114.993C150.855 116.336 151.43 118.032 151.43 120.024V123.069C151.43 124.812 151.028 126.386 150.205 127.769C149.411 129.145 148.287 130.22 146.851 130.986L146.839 130.992C145.397 131.728 143.744 132.084 141.9 132.085H137.583C134.65 132.085 132.285 131.074 130.58 129.012L130.577 129.007C128.889 126.933 128.09 124.109 128.09 120.624V119.914H134.615V120.624C134.615 122.126 134.919 123.221 135.451 123.983C135.984 124.684 136.693 125.035 137.658 125.035H141.825C142.803 125.035 143.517 124.791 144.036 124.368C144.565 123.925 144.83 123.361 144.831 122.608V121.039C144.831 120.437 144.656 120.013 144.353 119.697C144.036 119.366 143.512 119.087 142.696 118.919H142.694L135.79 117.489V117.49C133.436 117.008 131.569 116.076 130.264 114.642L130.259 114.636L130.253 114.629C129.054 113.251 128.434 111.541 128.36 109.544C127.971 109.147 127.636 108.626 127.636 107.996V107.929L127.648 107.865L128.1 105.462C128.121 105.29 128.183 105.145 128.241 105.041C128.314 104.908 128.408 104.786 128.503 104.678C128.506 104.675 128.509 104.671 128.512 104.668C128.69 103.673 129.016 102.751 129.497 101.908L129.499 101.905C130.292 100.525 131.406 99.4609 132.827 98.7222L132.832 98.7203C134.272 97.9851 135.912 97.6275 137.733 97.6275H141.975ZM201.261 97.6275C203.015 97.6275 204.593 98.0776 205.97 98.9917C207.344 99.9038 208.391 101.182 209.116 102.799H209.115C209.865 104.385 210.229 106.211 210.229 108.257V108.967H203.705V108.257C203.705 107.067 203.438 106.201 202.982 105.591L202.974 105.581C202.526 104.959 201.974 104.676 201.261 104.676H197.02C196.466 104.676 196.037 104.339 195.763 104.072C195.473 103.788 195.206 103.428 194.994 103.145C194.817 102.91 194.684 102.737 194.577 102.619C194.478 102.671 194.379 102.712 194.292 102.746C194.096 102.82 193.872 102.887 193.645 102.947C193.208 103.063 192.639 103.185 192.173 103.298C191.672 103.421 191.247 103.543 190.957 103.674C190.879 103.71 190.823 103.74 190.785 103.763L190.721 103.902L189.079 107.5C189.121 107.635 189.238 107.853 189.513 108.152C189.856 108.525 190.351 108.922 190.924 109.301C192.072 110.06 193.389 110.653 194.138 110.819L203.073 111.89L203.105 111.894L203.138 111.901C205.505 112.412 207.386 113.339 208.713 114.729L208.958 114.993C210.142 116.336 210.717 118.032 210.717 120.024V123.069C210.717 124.809 210.315 126.379 209.496 127.759C208.701 129.14 207.577 130.218 206.137 130.986L206.125 130.992C204.683 131.728 203.03 132.085 201.186 132.085H196.87C193.937 132.085 191.572 131.074 189.867 129.012L189.863 129.007C188.176 126.933 187.376 124.109 187.376 120.624V119.914H193.901V120.624C193.901 122.13 194.208 123.227 194.742 123.989C195.274 124.686 195.983 125.035 196.945 125.035H201.111C202.089 125.035 202.804 124.791 203.322 124.368C203.852 123.925 204.117 123.361 204.117 122.608V121.039C204.117 120.437 203.942 120.013 203.639 119.697C203.322 119.366 202.798 119.087 201.982 118.919H201.981L195.076 117.489V117.49C192.723 117.008 190.855 116.076 189.55 114.642L189.545 114.636L189.541 114.629C188.26 113.157 187.639 111.307 187.639 109.134V106.55C187.639 104.816 188.012 103.26 188.783 101.908L188.785 101.905C189.579 100.525 190.692 99.4609 192.113 98.7222L192.118 98.7203C193.559 97.985 195.199 97.6275 197.02 97.6275H201.261ZM161.287 97.9966L161.475 98.4166L169.415 116.148L177.18 98.4214L177.366 97.9966H183.157V131.715H176.669V113.875L172.509 123.129V123.13C172.167 123.889 171.79 124.519 171.365 124.975L171.174 125.166L171.173 125.165C170.669 125.619 170.063 125.855 169.385 125.855H165.305L165.149 125.357L161.987 115.222V131.715H155.5V97.9966H161.287Z"
        fill="#F0EEEE"
        stroke="#3F6EEC"
        strokeWidth="1.42"
      />
      <path
        d="M139.293 97.6275C141.047 97.6275 142.625 98.0775 144.002 98.9917C145.372 99.9011 146.417 101.175 147.141 102.786H147.142C147.896 104.375 148.261 106.205 148.261 108.257V108.967H141.737V108.257C141.737 107.067 141.472 106.201 141.015 105.591L141.006 105.581V105.58C140.559 104.958 140.006 104.676 139.293 104.676H135.052C134.135 104.676 133.461 104.914 132.967 105.331C132.513 105.734 132.271 106.27 132.271 107.012V108.257C132.271 108.887 132.444 109.328 132.735 109.65C133.035 109.982 133.529 110.26 134.299 110.424H134.3L141.169 111.901H141.17C143.537 112.412 145.419 113.339 146.746 114.729L146.991 114.993C148.175 116.336 148.75 118.032 148.75 120.024V123.069C148.75 124.809 148.347 126.379 147.528 127.759C146.734 129.14 145.609 130.218 144.169 130.986L144.158 130.992C142.715 131.728 141.062 132.084 139.218 132.084H134.902C131.969 132.084 129.604 131.074 127.899 129.012L127.895 129.007C126.208 126.933 125.409 124.109 125.409 120.624V119.914H131.933V120.624C131.933 122.13 132.24 123.227 132.774 123.989C133.307 124.686 134.015 125.035 134.977 125.035H139.143C140.123 125.035 140.839 124.791 141.358 124.366C141.886 123.924 142.149 123.36 142.149 122.608V121.039C142.149 120.437 141.975 120.013 141.671 119.697C141.354 119.366 140.83 119.087 140.014 118.919H140.013L133.108 117.489V117.49C130.755 117.008 128.888 116.076 127.583 114.642L127.578 114.636L127.573 114.629C126.292 113.157 125.671 111.307 125.671 109.134V106.55C125.671 104.816 126.045 103.26 126.815 101.908L126.817 101.905C127.611 100.525 128.725 99.4609 130.145 98.7222L130.15 98.7202C131.591 97.9849 133.231 97.6275 135.052 97.6275H139.293ZM198.58 97.6275C200.334 97.6275 201.912 98.0775 203.29 98.9917C204.663 99.9038 205.71 101.182 206.435 102.799H206.434C207.184 104.385 207.547 106.211 207.547 108.257V108.967H201.023V108.257C201.023 107.067 200.758 106.201 200.301 105.591L200.293 105.581C199.846 104.958 199.292 104.676 198.58 104.676H194.338C193.418 104.676 192.744 104.915 192.25 105.334C191.798 105.738 191.558 106.273 191.558 107.012V108.257C191.558 108.887 191.731 109.328 192.022 109.65C192.285 109.94 192.695 110.189 193.31 110.357L193.586 110.424L200.456 111.901H200.457C202.823 112.412 204.705 113.339 206.032 114.729L206.277 114.993C207.461 116.336 208.036 118.032 208.036 120.024V123.069C208.036 124.812 207.633 126.386 206.81 127.769C206.016 129.145 204.892 130.22 203.456 130.986L203.445 130.992C202.002 131.728 200.348 132.084 198.504 132.084H194.188C191.255 132.084 188.89 131.074 187.185 129.012L187.181 129.007C185.494 126.933 184.695 124.109 184.695 120.624V119.914H191.22V120.624C191.22 122.126 191.525 123.221 192.056 123.983C192.589 124.684 193.299 125.035 194.263 125.035H198.43C199.409 125.035 200.123 124.791 200.641 124.368C201.171 123.925 201.436 123.361 201.436 122.608V121.039C201.436 120.437 201.261 120.013 200.958 119.697C200.64 119.366 200.116 119.087 199.3 118.919H199.299L192.394 117.489C190.041 117.007 188.175 116.075 186.87 114.642L186.864 114.636L186.859 114.629C185.578 113.157 184.958 111.307 184.958 109.134V106.55C184.958 104.816 185.332 103.26 186.102 101.908L186.103 101.905C186.897 100.525 188.011 99.4609 189.431 98.7222L189.436 98.7202C190.877 97.9849 192.518 97.6275 194.338 97.6275H198.58ZM158.606 97.9966L158.793 98.4165L166.733 116.147L174.499 98.4214L174.685 97.9966H180.476V131.715H173.989V113.875L169.829 123.129L169.828 123.13C169.436 123.997 169.001 124.697 168.499 125.16L168.493 125.166L168.492 125.165C167.987 125.619 167.381 125.855 166.704 125.855H164.822L164.631 125.441L159.306 113.819V131.715H152.819V97.9966H158.606Z"
        fill="white"
        stroke="#3F6EEC"
        strokeWidth="1.42"
      />
      <path
        d="M256.861 20.1243H183.698C176.849 20.1243 171.297 25.6762 171.297 32.5248V57.3259C171.297 64.1745 176.849 69.7264 183.698 69.7264H256.861C263.71 69.7264 269.261 64.1745 269.261 57.3259V32.5248C269.261 25.6762 263.71 20.1243 256.861 20.1243Z"
        fill="#F0EEEE"
        stroke="black"
        strokeWidth="1.42"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M251.901 20.1243H178.738C175.449 20.1243 172.295 21.4308 169.969 23.7564C167.644 26.0819 166.337 29.236 166.337 32.5248V57.3259C166.337 64.3359 172.02 70.0187 179.03 70.0187H184.784L177.498 87.0871L201.059 69.7264H251.901C255.19 69.7264 258.344 68.4199 260.669 66.0944C262.995 63.7688 264.301 60.6147 264.301 57.3259V32.5248C264.301 29.236 262.995 26.0819 260.669 23.7564C258.344 21.4308 255.19 20.1243 251.901 20.1243Z"
        fill="white"
        stroke="black"
        strokeWidth="1.42"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M196.719 49.2655C199.116 49.2655 201.059 47.3224 201.059 44.9253C201.059 42.5283 199.116 40.5852 196.719 40.5852C194.322 40.5852 192.378 42.5283 192.378 44.9253C192.378 47.3224 194.322 49.2655 196.719 49.2655Z"
        fill="#F0EEEF"
        stroke="black"
        strokeWidth="1.42"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M215.319 49.2656C217.716 49.2656 219.659 47.3224 219.659 44.9254C219.659 42.5284 217.716 40.5852 215.319 40.5852C212.922 40.5852 210.979 42.5284 210.979 44.9254C210.979 47.3224 212.922 49.2656 215.319 49.2656Z"
        fill="#F0EEEF"
        stroke="black"
        strokeWidth="1.42"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M233.92 49.2656C236.317 49.2656 238.26 47.3224 238.26 44.9254C238.26 42.5284 236.317 40.5852 233.92 40.5852C231.523 40.5852 229.58 42.5284 229.58 44.9254C229.58 47.3224 231.523 49.2656 233.92 49.2656Z"
        fill="#F0EEEF"
        stroke="black"
        strokeWidth="1.42"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M265.542 33.1449C272.733 33.1449 278.562 27.3154 278.562 20.1243C278.562 12.9333 272.733 7.10378 265.542 7.10378C258.35 7.10378 252.521 12.9333 252.521 20.1243C252.521 27.3154 258.35 33.1449 265.542 33.1449Z"
        fill="#3E6EEC"
        stroke="black"
        strokeWidth="1.42"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M262.441 16.4041L266.782 13.304V27.5646"
        stroke="white"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M280.071 84.7C273.354 84.7 267.892 90.1625 267.892 96.8791V102.846H271.138V96.8791C271.138 91.9433 275.146 87.9351 280.071 87.9351C284.995 87.9351 289.003 91.9433 289.003 96.8791V102.846H292.25V96.8791C292.25 90.1625 286.787 84.7 280.071 84.7Z"
        fill="#F7F4F7"
        stroke="#3F6EEC"
        strokeWidth="1.42"
        strokeMiterlimit="10"
      />
      <path
        d="M278.038 119.663L279.499 123.866H273.251L274.792 119.64C273.658 119.033 272.896 117.859 272.896 116.496C272.896 114.544 274.483 112.952 276.452 112.952C278.422 112.952 279.997 114.538 279.997 116.496C279.997 117.876 279.195 119.09 278.044 119.663H278.038Z"
        fill="#F7F4F7"
        stroke="#3F6EEC"
        strokeWidth="1.42"
        strokeMiterlimit="10"
      />
      <path
        d="M289.009 102.845H271.139V102.88H289.009V102.845Z"
        fill="#F7F4F7"
        stroke="#3F6EEC"
        strokeWidth="1.42"
        strokeMiterlimit="10"
      />
      <path
        d="M295.841 102.845V121.707C295.841 128.641 290.218 134.264 283.284 134.264H276.865C283.799 134.264 289.433 128.641 289.433 121.707V102.845H295.841Z"
        fill="#F0EEEE"
        stroke="#3F6EEC"
        strokeWidth="1.42"
        strokeMiterlimit="10"
      />
      <path
        d="M289.004 102.845V102.88H271.133V102.845H264.302V121.707C264.302 128.641 269.925 134.264 276.859 134.264C283.793 134.264 289.427 128.641 289.427 121.707V102.845H289.004ZM279.499 123.865H273.251L274.792 119.64C273.658 119.033 272.896 117.859 272.896 116.496C272.896 114.543 274.483 112.952 276.452 112.952C278.422 112.952 279.997 114.538 279.997 116.496C279.997 117.876 279.195 119.09 278.044 119.662L279.504 123.865H279.499Z"
        fill="#F7F4F7"
        stroke="#3F6EEC"
        strokeWidth="1.42"
        strokeMiterlimit="10"
      />
      <path
        d="M278.038 119.663L279.499 123.866H273.251L274.792 119.64C273.658 119.033 272.896 117.859 272.896 116.496C272.896 114.544 274.483 112.952 276.452 112.952C278.422 112.952 279.997 114.538 279.997 116.496C279.997 117.876 279.195 119.09 278.044 119.663H278.038Z"
        fill="#F7F4F7"
        stroke="#3F6EEC"
        strokeWidth="1.42"
        strokeMiterlimit="10"
      />
      <path
        d="M289.009 102.845H271.139V102.88H289.009V102.845Z"
        fill="#F7F4F7"
        stroke="#3F6EEC"
        strokeWidth="1.42"
        strokeMiterlimit="10"
      />
      <path
        d="M276.452 113.452C278.145 113.452 279.497 114.813 279.497 116.496C279.497 117.641 278.851 118.654 277.918 119.163H277.335L277.566 119.827L278.796 123.366H273.966L275.262 119.811L275.41 119.404L275.027 119.199C274.048 118.675 273.396 117.665 273.396 116.496C273.397 114.82 274.758 113.452 276.452 113.452Z"
        fill="#3F6EEC"
        stroke="#3F6EEC"
      />
    </SvgIcon>
  )
}
